export default "__VITE_ASSET__C3wies5m__"